import React from 'react';

// TODO: validation to be added, renamed and placed to more appropriate place most likely
export default function ApplicationScreen(props) {
    return <React.Fragment {...props} />;
}
